import { commonAPI, flatOrganisations, RootState, useAppSelector } from '../';

const getSelectedOrganisationDetails = (s: RootState) => {
  const selectedOrgId = s.organisation.id;
  const { data } = commonAPI.endpoints.permissionsGetPermissionTree.select()(s);

  return flatOrganisations(data?.children ?? []).find((o) => o.id === selectedOrgId);
};

export const useSelectedOrganisation = () => {
  const selectedOrg = useAppSelector(getSelectedOrganisationDetails);
  return selectedOrg;
};
